var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        visible: _vm.visible,
        id: "admin-category-image-add-modal",
        title: "Add New Category Image",
        "hide-footer": "",
        centered: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Category Type" } },
            [
              _c("b-form-select", {
                attrs: {
                  options: _vm.categoryTypes,
                  state: _vm.fieldValid("category_type"),
                },
                model: {
                  value: _vm.formData.category_type,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "category_type", $$v)
                  },
                  expression: "formData.category_type",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("category_type") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.category_type) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Category" } },
            [
              _c("b-form-select", {
                attrs: {
                  options: _vm.categories,
                  state: _vm.fieldValid("category"),
                  disabled: !_vm.formData.category_type,
                },
                model: {
                  value: _vm.formData.category,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "category", $$v)
                  },
                  expression: "formData.category",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("category") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.category) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Image(s)" } },
            [
              _c("b-form-file", {
                attrs: {
                  state: _vm.fieldValid("images"),
                  placeholder: "Choose an images or drop it here",
                  "drop-placeholder": "Drop image here",
                  accept: "image/jpeg, image/png",
                  multiple: "",
                },
                model: {
                  value: _vm.formData.images,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "images", $$v)
                  },
                  expression: "formData.images",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("images") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.images) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                type: "submit",
                variant: "success",
                disabled: _vm.formState.processing,
              },
            },
            [
              _vm._v("\n      Submit\n      "),
              _vm.formState.processing
                ? _c("b-spinner", { staticClass: "ml-1", attrs: { small: "" } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              attrs: { type: "button", variant: "secondary" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }